import { makeStyles } from '@mui/styles';
const controlledInputStyles = makeStyles(({ palette }) => ({
    root: {
        paddingLeft: 0,
        flexGrow: 0,
        width: '100%',
        marginBottom: '12px',
        '& legend': {
            display: 'none',
        },
        '& fieldset': {
            top: 0,
        },
    },
    label: {
        display: 'flex',
        color: palette.text.primary,
        marginBottom: 6,
    },
    helper: {
        color: palette.error.main,
        overflowX: 'hidden',
    },
    textField: {
        flexGrow: 0,
        width: '100%',
    },
    error: {
        transitionDuration: '.1s',
    },
    inputRoot: {
        borderRadius: 0,
    },
    input: {},
    disabled: {
        background: 'none',
        color: palette.text.secondary,
        '&.Mui-disabled': {
            WebkitTextFillColor: palette.text.secondary,
        },
        zIndex: 2,
    },
    disabledNotchedOutline: {
        background: palette.text.disabled,
    },
    notchedOutline: {
        height: 'inherit',
    },
    iconButton: {
        padding: '0 8px',
    },
    labelAsterisk: {
        color: palette.error.main,
    },
}), { name: 'Login_ControlledInput' });
export default controlledInputStyles;
//# sourceMappingURL=controlledInput.styles.js.map